<template>
    <div class="card p-20 test-card" :style="{ '--module-color': moduleColor }">
        <div class="d-flex-row flex-justify-between m-b-md">
            <div class="d-flex-row flex-align-center flex-wrap badge-group">
                <span class="badge badge--module" :style="{ backgroundColor: moduleColor }" :title="moduleName">
                    {{ truncatedModuleName }}
                </span>
                <span class="badge badge--primary">
                    {{ test.schedule.type_assessment.name }}
                </span>
            </div>
            <span class="days-indicator" :style="{ color: daysColor }">
                <i class="fa fa-clock-o"></i>
                {{ daysLabel }}
            </span>
        </div>

        <div class="d-flex-column p-y-md text-left">
            <div class="d-flex-column">
                <small v-for="entry in academicEntries" :key="entry.key" class="academic-entry m-b-xs">
                    <strong>{{ entry.key }}:</strong> {{ entry.value }}
                </small>
            </div>
        </div>

        <div class="card-footer">
            <div class="col-xs-12 p-0 m-b-md text-left" v-if="test.end_date && !test.configs.hide_end_date">
                <small>Encerramento: {{ formatDbDatetime(test.end_date) }}</small>
            </div>

            <div class="col-xs-12 p-0 m-b-md d-flex-row flex-justify-between flex-align-center" v-if="!test.configs.param_hide_online_test_date">
                <small class="info">
                    <i class="fa fa-calendar"></i> {{ formatDbDate(test.schedule.date_schedule) }} às {{ test.schedule.time_schedule }}
                </small>
                <small class="info">
                    <i class="fa fa-clock-o"></i> {{ test.online_test_duration }} minutos
                </small>
            </div>

            <div class="col-xs-12">
                <div v-if="test.application_mode !== 'p'">
                    <router-link
                        v-if="!test.configs.use_examus_monitoring"
                        role="button"
                        class="col-xs-12 btn btn-default"
                        :to="`/online-tests/${test.item_generated}/instructions`"
                    >
                        Acessar avaliação
                    </router-link>
                    <a
                        v-else
                        role="button"
                        class="col-xs-12 btn btn-default"
                        :href="getBaseSgpUrl() + 'examusonlinetest/' + test.item_generated + '?use_new_layout=true'"
                    >
                        Acessar avaliação
                    </a>
                </div>
                <button v-else class="col-xs-12 btn btn-default" disabled>
                    Prova impressa
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { formatDbDate, formatDbDatetime, getModuleColor, getDaysColor, parseAcademic } from "../../scripts/utils";
import { getBaseSgpUrl } from "../../scripts/apiService/ApiService";

const MAX_MODULE_NAME_LENGTH = 39;

export default {
    name: 'TestCard',
    props: {
        test: {
            type: Object,
            required: true
        },
        moduleName: {
            type: String,
            default: null
        },
        daysUntilDue: {
            default: null
        }
    },
    computed: {
        truncatedModuleName() {
            if (!this.moduleName) return '';
            if (this.moduleName.length <= MAX_MODULE_NAME_LENGTH) return this.moduleName;
            return this.moduleName.substring(0, MAX_MODULE_NAME_LENGTH) + '...';
        },
        moduleColor() {
            return getModuleColor(this.moduleName);
        },
        daysColor() {
            return getDaysColor(this.daysUntilDue);
        },
        daysLabel() {
            const days = Number(this.daysUntilDue);
            if (isNaN(days) || this.daysUntilDue === null || this.daysUntilDue === undefined) return '--';
            if (days === 0) return 'Hoje';
            if (days === 1) return '1 dia';
            return `${days} dias`;
        },
        academicEntries() {
            return parseAcademic(this.test.academic);
        }
    },
    methods: {
        formatDbDate,
        formatDbDatetime,
        getBaseSgpUrl
    }
}
</script>
